// Texty procházení výprodeje (saleBrowse.js, saleBrowseModel.js) — slovenská sada.
import { plural } from '../plural.js';

const NBSP = '\u00A0';
const pct = (n) => n + NBSP + '%';
const products = (n) => plural(n, ['produkt', 'produkty', 'produktov']);

export default {
  params: {
    cat: 'kategoria',
    sub: 'podkategoria',
    disc: 'zlava',
    price: 'cena',
    brand: 'znacka',
    last: 'posledne-kusy',
    clearance: 'vypredaj',
    order: 'zoradenie',
  },
  orderSlugs: {
    bestseller: 'najpredavanejsie',
    discount: 'najvacsia-zlava',
    price_asc: 'najlacnejsie',
    price_desc: 'najdrahsie',
  },
  sortLabels: {
    bestseller: 'Najpredávanejšie',
    discount: 'Najväčšia zľava',
    price_asc: 'Najlacnejšie',
    price_desc: 'Najdrahšie',
  },

  tilesLabel: 'Kategórie vo výpredaji',
  count: (n) => n + ' ' + products(n),
  allIn: {
    garden: 'Všetko zo Záhrady',
    build: 'Všetko pre stavbu a dom',
    workshop: 'Všetko do dielne',
    home: 'Všetko do domácnosti',
    kids: 'Všetko pre deti',
    car: 'Všetko pre automobily',
    xmas: 'Všetko na Vianoce',
    ppe: 'Všetky ochranné pomôcky',
    solar: 'Všetko z fotovoltiky',
  },
  allFallback: 'Všetko',
  chipsLabel: 'Podkategórie',
  chipsMore: (n) => 'Ďalšie (' + n + ')',
  chipsLess: 'Menej',

  discount: 'Zľava',
  discFrom: (n) => 'od ' + pct(n),
  price: 'Cena',
  priceMin: 'Cena od',
  priceMax: 'Cena do',
  priceRange: (from, to) => from + ' – ' + to,
  brand: 'Značka',
  availability: 'Dostupnosť',
  lastPieces: 'Posledné kusy',

  flagAction: 'Zľavoakcia',

  // Žlutá dlaždice výprodeje skladu (filtruje na místě), claim z kampaně
  clearanceTitle: 'Výpredaj skladu',
  /** „až −30 %" */
  clearanceClaim: (n) => 'až −' + pct(n),

  more: (n) => 'Načítať ' + (n < 5 ? 'ďalšie ' : 'ďalších ') + n + ' ' + products(n),
  shown: (shown, total) => 'Zobrazené ' + shown + ' z ' + total + ' ' + products(total),

  emptyTitle: 'Výberu nezodpovedá žiadny produkt',
  emptyText: 'Skúste zrušiť niektorý z filtrov alebo vybrať inú kategóriu.',
  emptyCta: 'Zrušiť filtre',

  listName: (sale, slice) => (slice ? sale + ' – ' + slice : sale),
};
